module.exports = __webpack_public_path__ + "img/5.a646c9e5.gif";